import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is a HELOC?",
    a: "A Home Equity Line of Credit (HELOC) is a revolving line of credit secured by your home's equity. During the draw period, you can borrow what you need, repay it, and borrow again — similar to a credit card, but typically with a lower rate because it's secured by your home.",
  },
  {
    q: "How is a HELOC different from a home equity loan?",
    a: "A traditional home equity loan gives you a lump sum at closing with a fixed payment. A HELOC gives you flexible access to funds over time, and you only pay interest on what you actually use.",
  },
  {
    q: "How fast can I get funded?",
    a: "For qualified borrowers with documentation ready, funding may be available in as soon as 5 days. Actual timing varies based on borrower qualifications, documentation, and underwriting requirements.",
  },
  {
    q: "Will I have to refinance my first mortgage?",
    a: "Not necessarily. A HELOC may allow eligible homeowners to access equity without refinancing their existing first mortgage — which is helpful if you want to keep a favorable first-mortgage rate.",
  },
  {
    q: "What can I use a HELOC for?",
    a: "Common uses include home improvements, a new roof, HVAC upgrades, debt consolidation, education expenses, emergency costs, and major purchases. The funds are yours to use as you decide.",
  },
  {
    q: "How much can I borrow?",
    a: "Your line amount depends on factors such as your home's value, the equity you've built, your credit profile, and the program guidelines. We'll walk through the numbers with you during your no-obligation consultation.",
  },
  {
    q: "Are there closing costs?",
    a: "Some programs include closing costs and some do not. Randy will walk you through every cost so there are no surprises, and you can decide what works best for your situation.",
  },
  {
    q: "Is my application a hard credit pull?",
    a: "The Apply Now link on this page will take you to an application that will do a soft pull of credit. Other products may require a hard pull. Randy will explain what's involved upfront, so you understand exactly what to expect before anything impacts your credit.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 lg:py-32 bg-white border-t border-[#E2E8F0]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
        <div className="lg:col-span-4">
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#F26A21] mb-3">
            Frequently Asked
          </p>
          <h2
            data-testid="faq-heading"
            className="font-display font-bold text-[#0A2F6B] text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight"
          >
            Questions, answered clearly.
          </h2>
          <p className="mt-5 text-base text-[#475569] leading-relaxed">
            Don&rsquo;t see your question? Call Randy directly or request a callback below &mdash;
            no pressure, just straight answers.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((item, idx) => (
              <AccordionItem
                key={item.q}
                value={`faq-${idx}`}
                className="border-b border-[#E2E8F0]"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="text-left font-display font-semibold text-[#0A2F6B] text-base md:text-lg py-5 hover:no-underline hover:text-[#F26A21] transition-colors">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#475569] text-base leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
